module.exports = __webpack_public_path__ + "img/logo_en.97360f52.png";